import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import {
  Div, H3, Loading, P,
} from 'konsys-ui'
import config from './config'
import { status } from '../constants'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/filling-order-components'
import { FUEL_ORDER_LIST } from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import './style-css.css'
import { MobileFuelList } from './mobile'
import ROLE from '../../../constants/role'
import PERMISSION from '../../../constants/permissions'
import { DynamicButtonLink } from '../../../components/common/konsys-ui'

const { color } = theme

let refetchTimeout = null

const Index = () => {
  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)
  if (myInfoLoading || _.isEmpty(myInfo)) return <Loading center='true' />
  if (_.includes([ROLE.DRIVER.id, ROLE.FUEL_FILLER.id], myInfo.myInfo.Roles[0].id)) return <MobileFuelList />
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบเบิกน้ำมัน</H3>
        {
          /*
          <DynamicButtonLink
          condition={_.includes(window.perms, PERMISSION.CREATE_FUEL)}
          link='/fill-order/create-special'
          props={{ text: 'สร้างใบเบิกน้ำมันพิเศษ' }}
          />
          */
        }
      </Div>
      <List myInfoLoading={myInfoLoading} myInfo={myInfo} />
    </Div>
  )
}

export const List = ({ myInfoLoading, myInfo }) => {
  const [filtered, setFiltered] = useState([])
  const [sorted, setSorted] = useState([{ id: 'updatedAt', desc: true }])
  const [current, setCurrent] = useState(0)
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {myInfoLoading && _.isEmpty(myInfo) && <Loading center='true' />}
      {(!myInfoLoading || !_.isEmpty(myInfo))
        && <Query
          query={FUEL_ORDER_LIST}
          fetchPolicy='cache-and-network'
          variables={{
            limit: 20,
            offset: current * 20,
            orderBy: sorted[0].desc ? 'DESC' : 'ASC',
            orderField: sorted[0].id,
            driverId: myInfo.myInfo.driverId,
            ...filtered,
          }}
        >{({
          data, loading, error, refetch,
        }) => {
          if (loading && _.isEmpty(data)) return <Loading center='true' />
          if (error) return <P>เกิดข้อผิดพลาด</P>
          // if (!data.FuelOrderList) return <Loading center='true' />
          return (
            <Div>
              <ReactTable
                className='table'
                data={data.FuelOrderList.lists} // *
                resizable={false}
                columns={config.columns} // *
                minRows={5}
                row={data.FuelOrderList.lists.length}
                manual
                // defaultPageSize={10}
                showPageSizeOptions={false}
                getTdProps={() => ({ disabled: true, refetch })} // *
                getTrProps={(state, rowInfo) => { // *
                  if (rowInfo) {
                    return {
                      style: {
                        padding: '8px 0',
                        backgroundColor: '#ffffff',
                        borderLeft: rowInfo.original.status === status.WAITING
                          ? `3px solid ${color.coolGrey}`
                          : rowInfo.original.status === status.EXPIRED
                            ? `3px solid ${color.error}`
                            : rowInfo.original.status === status.FILLED
                              ? `3px solid ${color.success}`
                              : rowInfo.original.status === status.PRINTED
                                ? `3px solid ${color.wildWillow}`
                                : rowInfo.original.status === status.BILLED
                                  ? `3px solid ${color.info}`
                                  : rowInfo.original.status === status.CANCELLED
                                    ? `3px solid ${color.error}`
                                    : `3px solid ${color.lost}`,
                      },
                    }
                  } return {}
                }}
                previousText='ก่อนหน้า'
                nextText='ถัดไป'
                pageText='หน้า'
                ofText='จาก'
                noDataText='ไม่พบข้อมูล'
                page={current}
                pages={Math.ceil(data.FuelOrderList.totalFilter / 20)}
                onPageChange={page => setCurrent(page)}
                onFilteredChange={async (newFiltered) => {
                  const newObj = {}
                  await newFiltered.forEach((v) => {
                    switch (v.id) {
                      case 'ShippingOrder.shippingVolume':
                        Object.assign(newObj, {
                          shippingVolume: v.value,
                        })
                        break
                      case 'ShippingOrder.shippingNumber':
                        Object.assign(newObj, {
                          shippingNumber: v.value,
                        })
                        break
                      case 'ShippingOrder.assignDate':
                        Object.assign(newObj, {
                          assignDate: v.value,
                        })
                        break
                      case 'Gasstation.name':
                        Object.assign(newObj, {
                          name: v.value,
                        })
                        break
                      case 'Gasstation.company':
                        Object.assign(newObj, {
                          company: v.value,
                        })
                        break
                      case 'isSpecial':
                        switch (v.value) {
                          case 'NORMAL':
                            Object.assign(newObj, {
                              isSpecial: false,
                            })
                            break
                          case 'SPECIAL':
                            Object.assign(newObj, {
                              isSpecial: true,
                            })
                            break
                          default:
                            Object.assign(newObj, {
                              isSpecial: null,
                            })
                        }
                        break
                      default:
                        Object.assign(newObj, {
                          [v.id]: v.value,
                        })
                        break
                    }
                  })
                  clearTimeout(refetchTimeout)
                  refetchTimeout = setTimeout(() => {
                    setFiltered(newObj)
                  }, 750)
                  setCurrent(0)
                }}
                onSortedChange={async (newSorted) => {
                  const newOjb = {}
                  await newSorted.forEach((v) => {
                    switch (v.id) {
                      case 'ShippingOrder.shippingVolume':
                        Object.assign(newOjb, {
                          ...v,
                          id: 'shippingVolume',
                        })
                        break
                      case 'ShippingOrder.shippingNumber':
                        Object.assign(newOjb, {
                          ...v,
                          id: 'shippingNumber',
                        })
                        break
                      case 'ShippingOrder.assignDate':
                        Object.assign(newOjb, {
                          ...v,
                          id: 'assignDate',
                        })
                        break
                      case 'Gasstation.name':
                        Object.assign(newOjb, {
                          ...v,
                          id: 'name',
                        })
                        break
                      default:
                        Object.assign(newOjb, {
                          ...v,
                        })
                        break
                    }
                  })
                  setSorted([newOjb])
                  setCurrent(0)
                }}
              />
              {
                loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
              }
            </Div>
          )
        }}
        </Query>
      }
    </Wrapper>
  )
}
export default Index
